import {Component} from '@angular/core';

@Component({
	selector: 'mmmi-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'mmmi-web';
}
